import CoreApp from "./core/coreApp";
import LazyDisp from "./components/lazydisp";

const [d] = [document];

export default class CUSTOMIZE extends CoreApp {

  constructor(opt) {
    opt = Object.assign({
    },opt);

    super(opt);

    // this.toggleTags(); 
    this.customInit();
  }

customInit() {

    $(() => {
      $(document).off('click', '#hamburger-btn').on('click', '#hamburger-btn', function(e) {
        $(this).toggleClass('active');
        $('.nav_wrap_item').toggleClass('open');
        e.stopPropagation(); 
      });

      $(document).on('click', function(e) {
        if (!$(e.target).closest('.menu, #hamburger-btn').length) {
          $('#hamburger-btn').removeClass('active');
          $('.nav_wrap_item').removeClass('open');
        }
      });

      $(document).on('click', '.nav_wrap_item .menu a', function() {
        $('#hamburger-btn').removeClass('active');
        $('.nav_wrap_item').removeClass('open');
      });
    });
  }

  loading() {
  }
}

window.WebFontConfig = {
  google: {
    families: ['Roboto:100,400,500', 'Montserrat:400,500,600', 'Noto+Sans+JP:700,900']
  },
  active: function () {
    sessionStorage.fonts = true;
  }
};

(function () {
  var wf = document.createElement('script');
  wf.src = 'https://ajax.googleapis.com/ajax/libs/webfont/1.6.26/webfont.js';
  wf.type = 'text/javascript';
  wf.async = 'true';
  var s = document.getElementsByTagName('script')[0];
  s.parentNode.insertBefore(wf, s);
})();